import React, { useState } from 'react';
import {
  Row, Modal, message, notification,
} from 'antd';
import { useMutation } from '@apollo/client';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import MessageForm from './messageForm';
import Recipiant from './recipiant';
import { CREATE_MESSAGING, GET_MESSAGES } from '../../../graphql';
import { MESSAGING_EMAIL, MESSAGING_SMS } from '../../../routes';
import './styles.less';

const { confirm } = Modal;
const Detail = () => {
  const [step, setStep] = useState(1);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const url = pathname.split('/');
  const messageType = url[url.length - 2];
  const [messagePayload, setMessagePayload] = useState({
    title: null,
    body: null,
  });
  const [recipiant, setRecipiant] = useState(null);
  const [createMessage] = useMutation(CREATE_MESSAGING);
  const handleFormCompete = (inputs) => {
    setMessagePayload({ ...inputs });
    setStep(2);
  };
  const handleCreateMessage = async () => {
    try {
      const type = messageType.toUpperCase();
      // The sender comes from the token; delivery is batched server-side.
      await createMessage({
        variables: {
          input: {
            type,
            title: messagePayload.title,
            body: messagePayload.body,
            recipientIds: recipiant,
          },
        },
        update: (cache, { data: { createMessaging: created } }) => {
          const variables = { type };
          const cached = cache.readQuery({ query: GET_MESSAGES, variables });
          if (!cached) return;
          cache.writeQuery({
            query: GET_MESSAGES,
            variables,
            data: { sentMessages: [created, ...cached.sentMessages] },
          });
        },
      });
      notification.success({
        message: 'Message successfully sent',
        description: 'Your messages has been sent out',
      });
      const link = messageType === 'sms' ? MESSAGING_SMS : MESSAGING_EMAIL;
      navigate(link);
    } catch (error) {
      message.error('Error, could not send messages');
    }
  };
  const showConfirm = () => {
    confirm({
      title: 'Do you wish to send out messages',
      icon: <ExclamationCircleOutlined />,
      content: 'this action cannot be reverted or stopped, please confirm',
      onOk() {
        return handleCreateMessage();
      },
      onCancel() {
        message.info('message sending was canceled');
      },
    });
  };

  const handleSelectComplete = () => {
    if (!recipiant || recipiant.length < 1) {
      return message.error('No recipiant selected yet');
    }
    showConfirm();
  };

  return (
    <Row className="messaging">
      {step === 1 && <MessageForm initValue={messagePayload} type={messageType} onFormFinish={handleFormCompete} />}
      {step === 2 && (
        <Recipiant
          onSelectChange={setRecipiant}
          setStep={setStep}
          selectComplete={handleSelectComplete}
        />
      )}
    </Row>
  );
};
export default Detail;
